export class QueryResult {

  public registros: any = null
  public paginaActual: number = 0
  public totalPaginas: number = 0
  public totalRegistros: number = 0

  constructor(registros: any, paginaActual: number, totalPaginas: number, totalRegistros: number) {
    this.registros = registros
    this.paginaActual = paginaActual
    this.totalPaginas = totalPaginas
    this.totalRegistros = totalRegistros
  }
}
